import "./keywordCountSummary.scss";
import { dispatchEvent } from '../../shared/events';

class _Controller {
  constructor($limits, UserService, $resultsStore, $searchSettings) {
    this.searchSettings = $searchSettings;
    this.limits = $limits;
    this.$resultsStore = $resultsStore;
    this.isFreeUser = UserService.user.isFreeUser;
    this.user = UserService.user;
  }

  clickedDisabledSeeMoreKeywords() {
    dispatchEvent('clickedSeeMoreKeywords');
  }

}

_Controller.$inject = ['$limits', 'UserService', '$resultsStore', '$searchSettings'];

export const keywordCountSummary = {
  controller: _Controller,
  bindings: {
    results: '<',
    location: '@',
    explainer: '@',
    isFiltered: '<',
    fromDomain: '<'
  },
  template: require('./keywordCountSummary.html')
};
